module.exports = __webpack_public_path__ + "img/a1-6.882f83f5.png";